import { Close } from "@mui/icons-material"
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import TimeTrackingForm from "../shared/TimeTrackingForm"

function DetailsDialog({ open, onSave, onClose, workDay, lastEnd, nextStart, isFlexTime, contractInfo }) {

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth={'xl'}
            >
                <DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TimeTrackingForm
                        workDay={workDay}
                        onSave={onSave}
                        lastDayEnd={lastEnd}
                        nextDayStart={nextStart}
                        withLink={false}
                        isFlexTime={isFlexTime}
                        contractInfo={contractInfo}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default DetailsDialog